import React from "react";
import styled from "styled-components";
import { Table as BsTable } from "react-bootstrap";
import { VentaResumida } from "../../../services/ventasServicios";
import { formatearTiempoStr } from "../../../utils/dateUtils";
import { currencyFormat } from "../../../utils/numberUtils";
import { useUsuarioActual } from "../../../services/authServicios";
import {
  tieneRol,
} from "../../../services/rolAutorizacion";

function VentasPorPagarTable({
  items,
  onVentaSeleccionada,
}: TableSectionProps) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>Propietario</StyledColHeader>
          <StyledColHeader>Fecha</StyledColHeader>
          <StyledColHeader>Total</StyledColHeader>
          <StyledColHeader>Pendiente</StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {items.map((_) => (
          <TableItem
            key={_.id}
            item={_}
            onVentaSeleccionada={onVentaSeleccionada}
          />
        ))}
      </tbody>
    </StyledTable>
  );
}

interface TableSectionProps {
  items: VentaResumida[];
  onVentaSeleccionada: (venta: VentaResumida) => void;
}

interface TableItemProps {
  item: VentaResumida;
  onVentaSeleccionada: (venta: VentaResumida) => void;
}

function TableItem({ item, onVentaSeleccionada }: TableItemProps) {
  const { data: usuario } = useUsuarioActual();
  const puedeSeleccionar = tieneRol(usuario?.roles ?? [], "VISUALIZAR_PAGAR_VENTA");

  return (
    <StyledRow
      $clickable={puedeSeleccionar}
      onClick={() => {
        if (!puedeSeleccionar) return;
        onVentaSeleccionada(item);
      }}
    >
      <StyledCell>{item.nombresPropietario}</StyledCell>
      <StyledCell>{formatearTiempoStr(item.fecha)}</StyledCell>
      <StyledCell>{currencyFormat(item.total)}</StyledCell>
      <StyledCell>{currencyFormat(item.pendiente)}</StyledCell>
    </StyledRow>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")<{ $clickable?: boolean }>`
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
  &.active: {
    background-color: yellow;
  }
`;

export default VentasPorPagarTable;
